import PropTypes from 'prop-types';
import { d as dsBasicSizes } from '../prop-types-cc01d273.js';

var togglePropTypes = {
  /**
   * Set of Properties attached to the main container
   */
  containerProps: PropTypes.shape({}),

  /**
   * Whether the toggle has error or not
   */
  hasError: PropTypes.bool,

  /**
   * Whether the toggle is read only or not
   */
  readOnly: PropTypes.bool,

  /**
   * Whether the toggle is disabled or not
   */
  disabled: PropTypes.bool,

  /**
   * Whether the toggle is checked or not
   */
  checked: PropTypes.bool,

  /**
   * Allows a function that is triggered once the toggle changes
   */
  onChange: PropTypes.func,

  /**
   * Label to show when the toggle is ON
   */
  labelOn: PropTypes.string,

  /**
   * Label to show when the toggle is OFF
   */
  labelOff: PropTypes.string,

  /**
   * Default value once the component is initialized
   */
  value: PropTypes.string,

  /**
   * ['s', 'm', 'l']
   */
  size: PropTypes.oneOf(dsBasicSizes),

  /**
   * Input name
   */
  name: PropTypes.string
};

export { togglePropTypes };
//# sourceMappingURL=props.js.map
